var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "subcontainer" }, [
    _c("div", { staticClass: "status" }, [
      _vm.mappedStatus == "pickup"
        ? _c("img", {
            attrs: { src: require("../../static/pickup.png"), alt: "Pickup" },
          })
        : _vm.mappedStatus == "intransit"
        ? _c("img", {
            attrs: {
              src: require("../../static/intransit.png"),
              alt: "In Transit",
            },
          })
        : _vm.mappedStatus == "onboard"
        ? _c("img", {
            attrs: {
              src: require("../../static/onboard.png"),
              alt: "On Board",
            },
          })
        : _vm.mappedStatus == "delivered"
        ? _c("img", {
            attrs: {
              src: require("../../static/delivered.png"),
              alt: "Delivered",
            },
          })
        : _vm.mappedStatus == "none"
        ? _c("img", {
            attrs: {
              src: require("../../static/nostatus.png"),
              alt: "Delivered",
            },
          })
        : _c("img", {
            attrs: {
              src: require("../../static/nostatus.png"),
              alt: "Delivered",
            },
          }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }